import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

/**
 * The app's delete confirm (the shared sp-confirm card, as automations and
 * rooms use it): what goes, and that it can't be undone. Cancel on the left,
 * the red action on the right. Sits over any open slide panel.
 */
export default function ConfirmCard({ title, text, confirm = 'Remove', busyText = 'Removing…', busy = false, onCancel, onConfirm }) {
    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onCancel(); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [onCancel]);
    return ReactDOM.createPortal(
        <div className="sp-confirm-overlay" style={{ zIndex: 100020 }} onClick={onCancel}>
            <div className="sp-confirm-card" role="alertdialog" aria-modal="true" aria-labelledby="fd-confirm-title" onClick={(e) => e.stopPropagation()}>
                <div className="sp-confirm-icon sp-confirm-icon--danger" aria-hidden="true">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>
                </div>
                <h3 className="sp-confirm-title" id="fd-confirm-title">{title}</h3>
                <p className="sp-confirm-text">{text}</p>
                <div className="sp-confirm-actions">
                    <button type="button" className="sp-btn-secondary" onClick={onCancel} autoFocus>Cancel</button>
                    <button type="button" className="sp-btn-primary fd-btn-danger" onClick={onConfirm} disabled={busy}>{busy ? busyText : confirm}</button>
                </div>
            </div>
        </div>,
        document.body
    );
}
